import { fork, takeEvery } from "redux-saga/effects";

import ContactConstants from "modules/contact/constants";
import ContactSagas from "modules/contact/sagas";

function* watchGetContactInfo() {
  yield takeEvery(ContactConstants.GET_CONTACT_INFO, ContactSagas.GetContactInfo);
}

export default [fork(watchGetContactInfo)];
